import { Serializable } from '@/models/core/serializable';
import { LgateDeleteStudentInfo } from '@/models/lgate/lgate-delete-student-info';
export class LgatePreLinkage implements Serializable<LgatePreLinkage> {
  createCount: number = 0; // 新規作成数
  errorCount: number = 0; // エラー数
  updateDuplicateNameCount: number = 0; // 同姓同名チェック結果数
  updateNameOrMailAddressCount: number = 0; // 姓名とメールアドレス変更数
  updateOthersCount: number = 0; // 学籍番号と学年とクラスとタグと評価組み合わせグループ
  deleteCount: number = 0; // 削除数
  deleteStudents: LgateDeleteStudentInfo[] = [];

  deserialize(input: any) {
    this.createCount = input.createCount;
    this.errorCount = input.errorCount;
    this.updateDuplicateNameCount = input.updateDuplicateNameCount;
    this.updateNameOrMailAddressCount = input.updateNameOrMailAddressCount;
    this.updateOthersCount = input.updateOthersCount;
    this.deleteCount = input.deleteCount;
    if (input.deleteStudents != null) {
      this.deleteStudents = input.deleteStudents.map((student: LgateDeleteStudentInfo) => new LgateDeleteStudentInfo().deserialize(student));
    }

    return this;
  }
}
